import BaseAPI from '@/services/api/internal/tools/baseAPI';

const TechniciansAPI = new BaseAPI({
  url: `${process.env.P2H_BASE_URI}/staff`,
});

export default TechniciansAPI;
